export const bonus_buy_dialog = (t) => ({
	BONUS_BUY_DIALOG_HEADER: {
		value: 'BONUS BUY',
		config: {
			fontFamily: 'Japanese',
			fontSize: 50,
			letterSpacing: 5,
			fill: ['#EF9904', '#dd741d']
		}
	},

	BONUS_TRIGGER_TEXT: {
		value: 'BONUS SPINS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 45,
			letterSpacing: 5,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_TRIGGER_AMOUNT: {
		value: '+10',
		config: {
			fontFamily: 'Japanese',
			fontSize: 85,
			letterSpacing: 5,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_BUY_DIALOG_DESCRIPTION_0: {
		value: t('bonusBuyDialog.bonus_buy_dialog_description_0'),
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	BONUS_BUY_DIALOG_FREESPIN_AMOUNT: {
		value: '0',
		config: {
			fontFamily: 'Japanese',
			fontSize: 44,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_BUY_DIALOG_DESCRIPTION_1: {
		value: t('bonusBuyDialog.bonus_buy_dialog_description_1'),
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	BONUS_BUY_DIALOG_FREESPIN_COST: {
		value: '$200',
		config: {
			fill: ['#EF9904', '#dd741d'],
			lineHeight: 1,
			fontFamily: 'Japanese',
			fontSize: 60
		}
	},
	BONUS_BUY_DIALOG_YES_BTN: {
		value: t('bonusBuyDialog.yes'),
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	},
	BONUS_BUY_DIALOG_NO_BTN: {
		value: t('bonusBuyDialog.no'),
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	},
	BONUS_TRIGGERED: {
		value: t('bonus.bonus_triggered')
	},
	BONUS_SPINS_LEFT: {
		value: t('bonus.bonus_spins_left')
	},
	WIN: {
		value: t('bonus.win')
	}
});
